import type { IValidationField } from 'hooks/useValidations/types';
import { t } from 'i18next';
import * as yup from 'yup';

export default function envCropsPacks({ label = '', context }: IValidationField) {
  const { max } = context || {};

  let validation = yup
    .number()
    .label(label)
    .typeError(t('errors.required'))
    .when('packageReference', {
      is: (val) => !!val,
      then: (schema) => schema.required(),
      otherwise: (schema) => schema,
    })
    .positive()
    .integer(`${t('errors.integerNumber')}`);

  if (max) validation = validation.max(max);

  return validation;
}
